import { render, staticRenderFns } from "./bottomF.vue?vue&type=template&id=c249d358&scoped=true&"
import script from "./bottomF.vue?vue&type=script&lang=js&"
export * from "./bottomF.vue?vue&type=script&lang=js&"
import style0 from "./bottomF.vue?vue&type=style&index=0&id=c249d358&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c249d358",
  null
  
)

export default component.exports